import { EnvironmentModel } from '@core/models';

const serverUri = 'https://raven.bitvarklab.com/api';
const demoDatasetId = '654a6359ab90572075f89e84';

export const environment: EnvironmentModel = {
  production: false,
  locale: 'it-IT',
  envCode: 'dev',
  accountCode: 'BIB',
  appCode: 'cqs',
  flowCode: 'standalone',
  baseUrl: `${serverUri}/public/64c7be226cff71fd021943db/self-bibanca-cqs`,
  apiBaseUrl: `${serverUri}/public/64c7be226cff71fd021943db/self-bibanca-cqs`,
  securityBaseUrl: `${serverUri}/public/64c7be226cff71fd021943db/self-bibanca-cqs`,
  devMode: true,
  demoDatasetId
};
